import { useState } from "react";
import { createStatefulContext } from "../../../contexts/createStatefulContext";
import { useSfdcIntegrations } from "../hooks/useSfdcIntegrations";

export const {
  SalesforcePageContext,
  useSalesforcePageContext,
  useSalesforcePageContextFactory,
} = createStatefulContext("SalesforcePage", () => {
  const { data, loading, error, refetch } = useSfdcIntegrations();

  // State for controlling backdrop during integration creation/navigation
  const [showBackdrop, setShowBackdrop] = useState<boolean>(false);

  return {
    orgs: data?.integrations || [],
    loading,
    error,
    refetch,
    showBackdrop,
    setShowBackdrop,
  };
});
